import React from 'react';

import { useGetLoggedInUserLazyQuery } from 'generated/graphql';



export function useGetLoggedInUser() {
  const [
    fnMutate,
    tuple
  ] = useGetLoggedInUserLazyQuery({
  });

  const fnWrappedMutate = React.useCallback(
    async () => {
      await fnMutate({
        variables: {
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
